import React from 'react';
import styled from 'styled-components';

function StickyNotes({ onClose }) {
    return (
        <Div>
            <div className="sticky">
                <div className="sticky__header">
                    <div className="sticky__fold" />
                </div>
                <div className="sticky__content">
                    <p className="sticky__urgent">!!! VAT RETURN DUE FRIDAY !!!</p>
                    <p>Haven't done the books since June</p>
                    <p className="sticky__spacer" />
                    <p>PAYE - haven't submitted since August??</p>
                    <p className="sticky__sub">Is that bad? Karen from HMRC called twice</p>
                    <p className="sticky__spacer" />
                    <p className="sticky__urgent">Pension Regulator letter - URGENT</p>
                    <p className="sticky__sub">(been on my desk 3 weeks... maybe 4)</p>
                    <p className="sticky__spacer" />
                    <p>Making Tax Digital - what even IS this</p>
                    <p className="sticky__sub">Something about quarterly submissions?</p>
                    <p className="sticky__sub">Ask the accountant. Oh wait, we don't have one.</p>
                    <p className="sticky__spacer" />
                    <p>Corporation Tax - when is this due???</p>
                    <p className="sticky__sub">Google says 9 months after year end</p>
                    <p className="sticky__sub">When was our year end???</p>
                    <p className="sticky__spacer" />
                    <p className="sticky__urgent">Self Assessment: 31 Jan - 3 DAYS LEFT</p>
                    <p className="sticky__sub">Haven't started. Can't find login for HMRC gateway</p>
                    <p className="sticky__sub">Password might be in passwords.txt</p>
                    <p className="sticky__spacer" />
                    <p>CIS returns - what are these?</p>
                    <p className="sticky__sub">Something Gary mentioned. Google it tomorrow.</p>
                    <p className="sticky__spacer" />
                    <p>P11D forms due 6 July - ???</p>
                    <p className="sticky__sub">Benefits in kind? We give staff biscuits.</p>
                    <p className="sticky__sub">Does that count?</p>
                    <p className="sticky__spacer" />
                    <div className="sticky__cta">
                        <p>CALL DEAD SIMPLE ACCOUNTING</p>
                        <p className="sticky__phone">0118 359 3666</p>
                        <p className="sticky__sub">Before HMRC calls us. Again.</p>
                        <p className="sticky__web">deadsimpleaccounting.co.uk</p>
                    </div>
                </div>
            </div>
        </Div>
    );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ece9d8;
  font-family: Tahoma, sans-serif;

  .sticky {
    width: 90%;
    max-width: 360px;
    max-height: 90%;
    background: #ffff88;
    box-shadow: 3px 3px 10px rgba(0,0,0,0.3), 0 0 1px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .sticky__header {
    height: 24px;
    background: linear-gradient(to bottom, #ffffaa, #ffff88);
    border-bottom: 1px solid #e8e866;
    position: relative;
  }
  .sticky__fold {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, #ffff88 50%, #ddd 50%);
  }
  .sticky__content {
    padding: 12px 16px;
    font-family: 'Comic Sans MS', 'Segoe Print', cursive;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
    overflow-y: auto;
  }
  .sticky__urgent {
    color: #cc0000;
    font-weight: bold;
    font-size: 14px;
  }
  .sticky__sub {
    font-size: 11px;
    color: #666;
    margin-left: 8px;
  }
  .sticky__spacer {
    height: 8px;
  }
  .sticky__cta {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 2px dashed #cc9900;
    text-align: center;
    font-weight: bold;
    color: #003399;
  }
  .sticky__phone {
    font-size: 18px;
    color: #003399;
    font-weight: bold;
  }
  .sticky__web {
    font-size: 11px;
    color: #0066cc;
    font-weight: normal;
    margin-top: 4px;
  }
`;

export default StickyNotes;
